import { render } from "./DataMapperInvocationsAdmin.vue?vue&type=template&id=6132ca32&scoped=true"
import script from "./DataMapperInvocationsAdmin.vue?vue&type=script&lang=js"
export * from "./DataMapperInvocationsAdmin.vue?vue&type=script&lang=js"

import "./DataMapperInvocationsAdmin.vue?vue&type=style&index=0&id=6132ca32&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6132ca32"]])

export default __exports__